module.exports = __webpack_public_path__ + "c532554ba87a6857c75ead4487e9d71a.svg";